import React, {Fragment} from 'react';
import {Box, Button, LinearProgress, Stack, Typography} from '@mui/material';
import {IconIllustration} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {FileUploadProps} from '../../types';

const {loading: loadingText, cantLoadFile} = translations['pt-br'].others.uploadFiles.fileUpload;

const {tryAgain, send, cancel} = translations['pt-br'].commons;

export function FileUpload({
	title,
	size,
	loading,
	error,
	removeFile,
	sendFile,
	progress,
	removeButtonDataTagId,
}: FileUploadProps) {
	const {isTablet} = useMediaQueries();

	return (
		<Stack width="100%" bgcolor="white" p={2} borderRadius={0.5} gap={2}>
			<Stack direction="row" alignItems="center" spacing={2} flex={1}>
				<Box>
					<IconIllustration
						size="custom"
						variant={error ? 'error' : 'primary'}
						customIconName="upload-file-filled"
					/>
				</Box>
				<Stack spacing={2} width="100%">
					<Box>
						{error ? (
							<Fragment>
								<Typography variant="subtitle1" color="error">
									{title}
								</Typography>
								<Typography color="error">
									{isTablet
										? `${cantLoadFile}.`
										: `${cantLoadFile}. ${tryAgain}.`}
								</Typography>
							</Fragment>
						) : null}

						{!error ? (
							<Fragment>
								<Typography variant="subtitle1" color="text.primary">
									{title}
								</Typography>

								<Typography color="text.secondary" fontSize="0.875rem">
									{Math.round(size / 1000)} kb
									{loading ? ` • ${loadingText}` : null}
								</Typography>
								{loading ? (
									<LinearProgress
										sx={{borderRadius: 5, mt: 2}}
										variant="determinate"
										value={progress}
									/>
								) : null}
							</Fragment>
						) : null}
					</Box>
				</Stack>
			</Stack>

			{!loading ? (
				<Box display={'flex'} justifyContent={'flex-end'} gap={1}>
					<Button
						data-tag-id={removeButtonDataTagId}
						sx={{
							width: isTablet ? '50%' : 'auto',
							backgroundColor: 'transparent',
							color: 'primary',
							'&:hover': {
								backgroundColor: 'transparent',
							},
						}}
						variant="outlined"
						onClick={removeFile}>
						{cancel}
					</Button>
					<Button sx={{width: isTablet ? '50%' : 'auto'}} onClick={sendFile}>
						{error ? tryAgain : send}
					</Button>
				</Box>
			) : null}
		</Stack>
	);
}
